import * as ResultsFormatters from './resultsFormatters/index.js';
import * as ResultFormatters from './resultFormatters/index.js';
import * as Enums from './../enums/index.js';
import ResultPair from '../valueObjects/ResultPair.js';

const sessionResultsForRankingStatsFormatter = new ResultsFormatters.CompositeResultsFormatter(
    new ResultsFormatters.GenericResultFormatter([ 
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Sensor.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Tagging.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Scoring.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Sensor.key, ResultPair.getPitchProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Tagging.key, ResultPair.getPitchProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Scoring.key, ResultPair.getPitchProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        )
    ], [
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Sensor.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Tagging.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Scoring.key],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Sensor.key, ResultPair.getHitProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Tagging.key, ResultPair.getHitProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            [Enums.ResultDataNew.Data.key, Enums.DataSection.Scoring.key, ResultPair.getHitProperty()],
            (value) => (typeof(value) !== 'undefined' && value !== null), {}
        )
    ]),
    new ResultsFormatters.PlateAppearanceFormatter(true),
    new ResultsFormatters.PitchCountFormatter(undefined, true),
    new ResultsFormatters.BattedBallTypeFormatter(undefined, true),
    new ResultsFormatters.QualityOfContactFormatter(undefined, true),
    new ResultsFormatters.GenericResultFormatter([ 
        new ResultFormatters.PropertyAssuranceFormatter(
            Enums.ResultDataNew.getDataPath(Enums.PitchData.Classification.key, Enums.DataSection.Tagging.key, Enums.ResultType.Pitch.key),
            (value) => (typeof(value) !== 'undefined'), Enums.BaseballPitchType.Unidentified.key
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            Enums.ResultDataNew.getDataPath(Enums.PitchData.Handedness.key, Enums.DataSection.Tagging.key, Enums.ResultType.Pitch.key),
            (value) => (typeof(value) !== 'undefined'), Enums.Handedness.Unidentified.key
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            Enums.ResultDataNew.getDataPath(Enums.PitchData.SwingHandedness.key, Enums.DataSection.Tagging.key, Enums.ResultType.Pitch.key),
            (value) => (typeof(value) !== 'undefined'), Enums.Handedness.Unidentified.key
        ),
        new ResultFormatters.EnumValuesFormatter([
            Enums.PitchData.Classification,
            Enums.PitchData.SwingHandedness, Enums.PitchData.Handedness,
            // old scoring bbh, disabled for now as we do not group data by this property
            // Enums.PitchData.Result, Enums.PitchData.Mechanics,
            // new scoring, disabled for now as we do not group data by this property
            // Enums.ScoringData.PitchCall, Enums.ScoringData.PlateAppearanceResult,
        ], [ Enums.DataSection.Tagging.key, Enums.ResultType.Pitch.key] ),
        // yes, it is possible that sometimes pitch will have a hit tagging on
        new ResultFormatters.EnumValuesFormatter([
            Enums.HitData.SwingHandedness, Enums.PitchData.Handedness
        ], [ Enums.DataSection.Tagging.key, Enums.ResultType.Hit.key] )
    ], [
        new ResultFormatters.PropertyAssuranceFormatter(
            Enums.ResultDataNew.getDataPath(Enums.PitchData.Handedness.key, Enums.DataSection.Tagging.key, Enums.ResultType.Hit.key),
            (value) => (typeof(value) !== 'undefined'), Enums.Handedness.Unidentified.key
        ),
        new ResultFormatters.PropertyAssuranceFormatter(
            Enums.ResultDataNew.getDataPath(Enums.PitchData.SwingHandedness.key, Enums.DataSection.Tagging.key, Enums.ResultType.Hit.key),
            (value) => (typeof(value) !== 'undefined'), Enums.Handedness.Unidentified.key
        ),
        new ResultFormatters.EnumValuesFormatter([
            Enums.HitData.SwingHandedness, Enums.PitchData.Handedness
        ], [ Enums.DataSection.Tagging.key, Enums.ResultType.Hit.key] ),
        // yes, sometimes it is possible that hit has pitch tagging in
        new ResultFormatters.EnumValuesFormatter([
            Enums.PitchData.Classification,
            Enums.PitchData.SwingHandedness, Enums.PitchData.Handedness,
            // old scoring bbh, disabled for now as we do not group data by this property
            // Enums.PitchData.Result, Enums.PitchData.Mechanics,
            // new scoring, disabled for now as we do not group data by this property
            // Enums.ScoringData.PitchCall, Enums.ScoringData.PlateAppearanceResult,
        ], [ Enums.DataSection.Tagging.key, Enums.ResultType.Pitch.key] ),
    ], true)
);

export default sessionResultsForRankingStatsFormatter;